import { axios } from '@/utils/request'

const api = {
  userList: '/adminapi/user/userlist',
  photoList: '/adminapi/user/userPhotoList',
  partnerList: '/adminapi/user/partnerlist',
  partnerCashList: '/adminapi/user/partnerCashList',
  userDetail: '/adminapi/user/userdetail',
  userPhotoDetail: '/adminapi/user/userPhotoDetail',
  userEdit: '/adminapi/user/useredit',
  userStatusEdit: '/adminapi/user/userPhotoStatusEdit',
  userPhotoStatusEditAll: '/adminapi/user/userPhotoStatusEditAll',
  userPhotoEdit: '/adminapi/user/userPhotoEdit',
  userGroupList: '/adminapi/user/userGroupList',
  setPassword: '/adminapi/user/setPassword',
  userOptions: '/adminapi/user/userOptions',
  editPassword: '/adminapi/user/editPassword',
}

export default api

export function getUserList(parameter) {
  return axios({
    url: api.userList,
    method: 'get',
    params: parameter
  })
}

export function getPhotoList(parameter) {
  return axios({
    url: api.photoList,
    method: 'get',
    params: parameter
  })
}

export function getPartnerList(parameter) {
  return axios({
    url: api.partnerList,
    method: 'get',
    params: parameter
  })
}
export function getPartnerCashList(parameter) {
  return axios({
    url: api.partnerCashList,
    method: 'get',
    params: parameter
  })
}

export function editPassword(parameter) {
  return axios({
    url: api.editPassword,
    method: 'post',
    data: parameter
  })
}
export function getUserDetail(parameter) {
  return axios({
    url: api.userDetail,
    method: 'get',
    params: parameter
  })
}

export function getUserPhotoDetail(parameter) {
  return axios({
    url: api.userPhotoDetail,
    method: 'get',
    params: parameter
  })
}

export function editUserPhoto(parameter) {
  return axios({
    url: api.userPhotoEdit,
    method: 'post',
    data: parameter
  })
}

export function editUserPhotoStatus(parameter) {
  return axios({
    url: api.userStatusEdit,
    method: 'post',
    data: parameter
  })
}

export function editUserPhotoStatusAll(parameter) {
  return axios({
    url: api.userPhotoStatusEditAll,
    method: 'post',
    data: parameter
  })
}

export function editUser(parameter) {
  return axios({
    url: api.userEdit,
    method: 'post',
    data: parameter
  })
}

export function getUserGroupList(parameter) {
  return axios({
    url: api.userGroupList,
    method: 'get',
    params: parameter
  })
}
export function setPassword(parameter) {
  return axios({
    url: api.setPassword,
    method: 'get',
    params: parameter
  })
}


export function getUserOptions(parameter) {
  return axios({
    url: api.userOptions,
    method: 'get',
    params: parameter
  })
}

